import React from 'react';
import PropTypes from 'prop-types';

// Components
// SVGs
// Constants
// Styles
import './Button.css';

// Prop Types

export default class Button extends React.Component {

  static propTypes = {
    className: PropTypes.string,
    value: PropTypes.string.isRequired,
    type: PropTypes.string,
    hollow: PropTypes.bool,
    isLoading: PropTypes.bool,
    onClick: PropTypes.func
  };
  static defaultProps = {
    className: '',
    type: 'button',
    hollow: false,
    isLoading: false,
    icon: null,
    link: null,
    onClick: () => {},
    refFunc: () => {}
  };

  render() {
    return (
      <button
        ref={ this.props.refFunc }
        className={`
          button
          ${this.props.className}
          ${this.props.isLoading ? 'is-loading' : ''}
          ${this.props.shape ? `button--${this.props.shape}` : ''}
          ${this.props.hollow ? 'button--hollow' : ''}
        `}
        onClick={this.props.onClick}
        type={this.props.type}
      >
        {this.props.link ?
          ( <a target="_blank" href={`${this.props.link}`} rel="noopener noreferrer">{ this.props.value }</a> )
          :
          this.props.value
        }
      </button>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/_shared/Button/Button.js